import React, { Component } from 'react'
import '../styles/MarketChainStudy.css'
import OrgFooter from '../widgets/OrgFooter'
import DropdownWidget from '../widgets/DropdownWidget'
import InputTextFilterWidget from '../widgets/InputTextFilterWidget'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'
import TickBoxWidget from '../widgets/TickBoxWidget'
import APISiteRequest from '../api/APISiteRequest'
import APIFarmerRequest from '../api/APIFarmerRequest'

class ProspectiveBuyerForm extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user: JSON.parse(sessionStorage.getItem("user")),
			clusterId: sessionStorage.getItem("cluster-id"),
			siteId: props.siteId,
			scrollable: false,
			mop: "-- SELECT --",
			unit: "-- SELECT --",
			frequency: "DOES NOT REPEAT",
			frequencyId: 1,
			repeatEvery: 0,
			disabled: props.disabled,
			pbid: props.pbid
		}
		this.onSubmit = this.onSubmit.bind(this)
		this.getAllCrops = this.getAllCrops.bind(this)
		this.getProspectiveBuyerById = this.getProspectiveBuyerById.bind(this)
		this.handleFooterEvent = this.handleFooterEvent.bind(this)
		this.requiredInputAlertMessage = this.requiredInputAlertMessage.bind(this)
		this.addProspectiveBuyerBySiteId = this.addProspectiveBuyerBySiteId.bind(this)
		this.editProspectiveBuyerById = this.editProspectiveBuyerById.bind(this)
	}

	onSubmit() {
		if(this.state.targetBuyer == null) {
			this.requiredInputAlertMessage('Target Market/Buyer')
			return
		}
		console.log('this.state.cropId', this.state.cropId)
		if(this.state.cropId == null || this.state.cropId == -1) {
			this.requiredInputAlertMessage('Target Crop')
			return
		}
		if(this.state.qualityReq == null) {
			this.requiredInputAlertMessage('Output Quality Requirement')
			return
		}
		if(this.state.unitPrice == null || this.state.unitPrice == 0) {
			this.requiredInputAlertMessage('Unit Price')
			return
		}
		if(this.state.volume == null || this.state.volume == 0) {
			this.requiredInputAlertMessage('Volume')
			return
		}
		if(this.state.unitId == null) {
			this.requiredInputAlertMessage('Unit of Measurement')
			return
		}
		if(this.state.mop == null) {
			this.requiredInputAlertMessage('Mode of Payment')
			return
		}
		if(this.state.repeatEvery == null) {
			this.requiredInputAlertMessage('Delivery Frequency/Schedule')
			return
		}
		this.setState({showActivityIndicator: true})
		const data = {
			"site_id": this.state.siteId,
			"crop_id": this.state.cropId,
			"target_market_name": this.state.targetBuyer.toUpperCase(),
			"output_quality_req": this.state.qualityReq,
			"unit_price": this.state.unitPrice,
			"measurement_id": this.state.unitId,
			"volume": this.state.volume,
			"mode_of_payment_id": this.state.mopId,
			"notes_on_payment": this.state.notes,
			"repeat_every": this.state.repeatEvery,
			"delivery_frequency_id": this.state.frequencyId,
			"on_the_following_days": this.state.days,
			"delivery_end_date": this.state.deliveryEnd
		}
		if(this.state.prospectiveBuyerId == null) {
			this.addProspectiveBuyerBySiteId(data)
			// const apiReq = APISiteRequest.addProspectiveBuyerBySiteId(this.state.accessToken, data, this.state.siteId)
			// apiReq.then((response) => {
			// 	if(response.status !== "SUCCESS") {
			// 		this.setState({
			// 			showWarningMessage: true,
			// 			aMessage: response.status + "! " + response.description + ": " + response.results,
			// 			showActivityIndicator: false
			// 		})
			// 		return
			// 	}
			// 	this.setState({
			// 		showInfoMessage: true,
			// 		aMessage: response.status + "! " + response.description,
			// 		showActivityIndicator: false
			// 	})
			// })
		}
		else {
			this.editProspectiveBuyerById(data)
			// const apiReq = APISiteRequest.editProspectiveBuyerById(this.state.accessToken, data, this.state.prospectiveBuyerId)
			// apiReq.then((response) => {
			// 	if(response.status !== "SUCCESS") {
			// 		this.setState({
			// 			showWarningMessage: true,
			// 			aMessage: response.status + "! " + response.description + ": " + response.results,
			// 			showActivityIndicator: false
			// 		})
			// 		return
			// 	}
			// 	this.setState({
			// 		showInfoMessage: true,
			// 		aMessage: response.status + "! " + response.description,
			// 		showActivityIndicator: false
			// 	})
			// })
		}
	}
	
	addProspectiveBuyerBySiteId(data) {
		const apiReq = APISiteRequest.addProspectiveBuyerBySiteId(this.state.accessToken, data, this.state.siteId)
		apiReq.then((response) => {
			if(response.status !== "SUCCESS") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + response.description,
				showActivityIndicator: false
			})
		})
	}

	editProspectiveBuyerById(data) {
		const apiReq = APISiteRequest.editProspectiveBuyerById(this.state.accessToken, data, this.state.prospectiveBuyerId)
		apiReq.then((response) => {
			console.log('editProspectiveBuyerById',this.state.siteId , response)
			if(response.status !== "SUCCESS") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + response.description,
				showActivityIndicator: false,
				disabled: true
			})
		})
	}

	requiredInputAlertMessage(str) {
		this.setState({
			showWarningMessage: true,
			aMessage: `${str} is required. All fields with the asterisk (*) symbol must have values.`
		})
	}

	handleFooterEvent(e) {
		console.log('handleFooterEvent ProspectiveBuyerForm', e.innerHTML)
		if(e.innerHTML === "UPDATE") {
			console.log('handleFooterEvent 2')
			this.setState({disabled: false})
		}
		else {
			console.log('handleFooterEvent 3')
			this.props.handleFooterEvent(e)
		}
	}

	componentWillMount() {
		console.log('site id', this.state.siteId)
		this.getAllCrops()
		this.getProspectiveBuyerById()
	}

	getAllCrops() {
		const types = APIFarmerRequest.getAllCrops(this.state.accessToken)
		types.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.crop_id, name: v.name})
			}
			localStorage.setItem("crops", JSON.stringify(c))
			this.setState({crops: c})
		})
	}

	getProspectiveBuyerById() {
		const apiReq = APISiteRequest.getProspectiveBuyerById(this.state.accessToken, this.state.pbid)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			if(response.results.on_the_following_days != null) {
				var tbDefault = response.results.on_the_following_days.split(',').map((item) => {
					return(parseInt(item, 6))
				})
			}
			this.setState({
				prospectiveBuyerId: response.results.mcs_prospective_buyer_id,
				targetBuyer: response.results.target_market_name,
				targetCrop: response.results.crop,
				cropId: response.results.crop_id,
				qualityReq: response.results.output_quality_req,
				unitPrice: parseInt(response.results.unit_price),
				volume: parseInt(response.results.volume),
				unit: response.results.measurement.toUpperCase(),
				mop: response.results.mode_of_payment,
				noteOnPayment: response.results.notes_on_payment,
				repeatEvery: parseInt(response.results.repeat_every),
				frequency: response.results.delivery_frequency,
				frequencyId: response.results.delivery_frequency_id, 
				deliveryEnd: response.results.delivery_end_date,
				tbDefault: tbDefault,
				days: response.results.on_the_following_days,
				unitId: response.results.measurement_id,
				mopId: response.results.mode_of_payment_id
			})
			const elem = document.getElementById('ta-note')
			elem.style.height = "20px"
			elem.style.height = (elem.scrollHeight - 4) + "px"
		})
	}

	render() {
		const view = <div id="market-chain-study">
			<div id="mcs-scroll-area"><div id="mcs-client-area">
				<div className="title-bar">{this.state.pbid == null && <span>ADD </span>}TARGET MARKET/BUYER</div>
				<div id="mcs-cell1">
					<div className="mcs-cell1-row">
						<div id="mcs-cell1-r1-i1">
							<div>* Target Market / Buyer</div>
							<input type="text" value={this.state.targetBuyer} onChange={(e) => {
								this.setState({targetBuyer: e.target.value})
							}} disabled={this.state.disabled} />
						</div>
						<div id="mcs-cell1-r1-i2">
							<div>* Target Crop</div>
							<InputTextFilterWidget list={this.state.crops} placeholder={this.state.targetCrop}
								onChange={(val) => {
									console.log('vvalue', val)
									if(val === '') {
										this.setState({cropId: -1})
									}
								}}
								onItemSelected={(id, val) => {
									console.log("crops", id, val)
									this.setState({cropId: id})
								}} cStyle={{"width": "100%"}} disabled={this.state.disabled} />
						</div>
						<div id="mcs-cell1-r1-i3">
							<div>* Output Quality Requirement</div>
							<input type="text" value={this.state.qualityReq} onChange={(e) => {
								this.setState({qualityReq: e.target.value})
							}} disabled={this.state.disabled} />
						</div>
					</div>
					<div className="mcs-cell1-row">
						<div id="mcs-cell1-r2-i1">
							<div>* Unit Price</div>
							<input type="text" value={this.state.unitPrice} placeholder='0.0' onChange={(e) => {
								if(isCurrencyValid(e.target.value)) {
									const v = e.target.value.replace(/,/g, "")
									this.setState({unitPrice: v})
									e.target.value = formatCurrency(e.target.value)
								}
								else {
									if(isNaN(parseInt(e.target.value))) {
										e.target.value = ""
									}
									else {
										const v = e.target.value.replace(/,/g, "")
										e.target.value = parseInt(v)
										e.target.value = e.target.value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
									}
								}
							}} disabled={this.state.disabled} />
						</div>
						<div id="mcs-cell1-r2-i2">
							<div>* Volume</div>
							<input type="text" value={this.state.volume} placeholder='0' onChange={(e) => {
								if(isCurrencyValid(e.target.value)) {
									const v = e.target.value.replace(/,/g, "")
									this.setState({volume: parseInt(v)})
									e.target.value = formatCurrency(e.target.value)
								}
								else {
									if(isNaN(parseInt(e.target.value))) {
										e.target.value = ""
									}
									else {
										const v = e.target.value.replace(/,/g, "")
										e.target.value = parseInt(v)
										e.target.value = e.target.value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
									}
								}
							}} disabled={this.state.disabled} />
						</div>
						<div id="mcs-cell1-r2-i3">
							<div>* Unit of Measurement</div>
							<DropdownWidget list={unitsOfMeasurement} placeholder={this.state.unit}
								onItemSelected={(id, val) => {
									this.setState({unitId: id})
								}} disabled={this.state.disabled} cStyle={{"width": "100%"}} />
						</div>
						<div id="mcs-cell1-r2-i4">
							<div>* Mode of Payment</div>
							<DropdownWidget list={modesOfPayment} placeholder={this.state.mop} cStyle={{"width": "100%"}}
								onItemSelected={(id, val) => {
									this.setState({mopId: id})
								}} disabled={this.state.disabled} />
						</div>
						<div id="mcs-cell1-r2-i5">
							<div>Notes on Payment</div>
							<textarea id="ta-note" value={this.state.noteOnPayment} onChange={(e) => {
								this.setState({notes: e.target.value, noteOnPayment: e.target.value})
							}} onKeyUp={(e) => {
								e.target.style.height = "20px"
								e.target.style.height = (e.target.scrollHeight - 4) + "px"
							}} disabled={this.state.disabled} />
						</div>
					</div>
					<div className="mcs-cell1-row">
						<div id="mcs-cell1-r3-i2">
							<div>* Delivery Frequency/Schedule</div>
							<input type="number" value={this.state.repeatEvery} onChange={(e) => {
								if(isCurrencyValid(e.target.value)) {
									const v = e.target.value.replace(/,/g, "")
									this.setState({repeatEvery: parseInt(v)})
									e.target.value = formatCurrency(e.target.value)
								}
								else {
									if(isNaN(parseInt(e.target.value))) {
										e.target.value = ""
									}
									else {
										const v = e.target.value.replace(/,/g, "")
										e.target.value = parseInt(v)
										e.target.value = e.target.value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
									}
								}
							}} disabled={this.state.disabled} />
						</div>
						<div id="mcs-cell1-r3-i3">
							<div><br/></div>
							<DropdownWidget list={periods} placeholder={this.state.frequency} cStyle={{"width": "100%"}}
								onItemSelected={(id, val) => {
									this.setState({frequencyId: parseInt(id)})
								}} disabled={this.state.disabled} />
						</div>
						<div id="mcs-cell1-r3-i4">
							<div>On the following days</div>
							<TickBoxWidget
								name="frequency"
								options={dayOptions}
								direction="row"
								default={this.state.tbDefault}
								optionSelected={(value) => {
									const days = Object.keys(value.options)
									this.setState({days: days.join(',')})
								}} disabled={this.state.disabled} />
						</div>
					</div>
				</div>
			</div>
			</div>
			{this.state.scrollable === false && <div className="alternate-footer">
				<OrgFooter submit={this.onSubmit} eventHandler={this.handleFooterEvent}
					showSubmit={!this.state.disabled}
					showCancel={!this.state.disabled}
					showClose={this.state.disabled}
					showUpdate={(this.state.user.role_id == 3)? this.state.disabled: false} /></div>}
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					this.setState({showInfoMessage: false})
					this.props.handleFooterEvent()
				}} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

const dayOptions = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"]
const modesOfPayment = [
	{id: 1, name: "CASH"},
	{id: 2, name: "CHECK"},
	{id: 3, name: "INSTALLMENT"},
	{id: 4, name: "CONSIGNMENT"},
]
const unitsOfMeasurement = [
	{id: 1, name: "KG"},
	{id: 2, name: "TON"}
]
const periods = [
	{id: 1, name: "DOES NOT REPEAT"},
	{id: 2, name: "DAY"},
	{id: 3, name: "WEEK"},
	{id: 4, name: "MONTH"},
	{id: 5, name: "YEAR"}
]

const formatCurrency = (value) => {
	const v = value.replace(/,/g, "")
	const c = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
	return(c)
}

const isCurrencyValid = (value) => {
	const checker = /^[\d,]+\.?\d{0,2}?$/
	const isValid = checker.test(value)
	console.log(value, isValid)
	return(isValid)
}

export default ProspectiveBuyerForm
